<template>
  <div>
    <label>Filter By Client</label>
    <el-select
      class="select-primary"
      size="large"
      placeholder="Select Client"
      filterable
      default-first-option
      :loading="isGroupListLoading"
      :disabled="isGroupListLoading"
      v-model="selectedGroupCompany"
      v-on:change="onGroupChange($event)"
    >
      <el-option
        v-for="(item, index) in companyGroupList"
        class="select-primary"
        :value="String(item.id)"
        :label="(item.group_name == null || item.group_name === false) ? '' : String(item.group_name)"
        :key="index">
      </el-option>
    </el-select>
  </div>
</template>

<script>
import { Select, Option } from 'element-ui';

export default {
  name: 'select-client-dropdown-dashboard',
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
  },
  props: {
    isGroupListLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedGroupCompany: ''
    }
  },
  computed: {
    companyGroupList() {
      return this.$global.selectsGroupCompany.companyGroupList || [];
    },
  },
  watch: {
    isGroupListLoading(isLoading) {
      if (!isLoading) {
        this.syncSelectionFromStorage();
      }
    },
    companyGroupList() {
      if (!this.isGroupListLoading) {
        this.syncSelectionFromStorage();
      }
    },
  },
  methods: {
    onGroupChange(event) {
      localStorage.setItem('companyGroupSelected', event);
      this.$router.go();
    },
    syncSelectionFromStorage() {
      const list = this.companyGroupList;
      if (!list.length) {
        this.selectedGroupCompany = '';
        return;
      }

      const storedGroup = localStorage.getItem('companyGroupSelected');
      if (storedGroup == null || storedGroup === '') {
        this.selectedGroupCompany = '';
        return;
      }

      const storedGroupStr = String(storedGroup);
      const hasMatch = list.some(item => String(item.id) === storedGroupStr);
      this.selectedGroupCompany = hasMatch ? storedGroupStr : '';
    },
  },
  mounted() {
    if (!this.isGroupListLoading) {
      this.syncSelectionFromStorage();
    }
  },
}
</script>
